import AppDispatcher from '../dispatcher/AppDispatcher';
import { NAVIGATION_URL } from '../constants/DigitalStatementConstants';

export function getNavigationUrl(data) {
  AppDispatcher.handleViewAction({
    actionType: NAVIGATION_URL,
    data,
  });
}
